import { z } from 'zod';

export const tokenResDto = z.object({
  token_type: z.literal('Bearer'),
  expires_in: z.number(),
  access_token: z.string(),
  refresh_token: z.string(),
});
export type TokenResDto = z.infer<typeof tokenResDto>;
